import { ReactElement } from 'react'
import { Box, useTheme } from '@mui/material'
import { isUtilizationError, isUtilizationWarning, isVibrationError } from '../utils'

const numberFormatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const fmt = (value: number) => numberFormatter.format(value)

type Props = {
  label: string
  maxUtilization: number
  checkType?: MemberCheckType
  allowedOverutilizationPercent?: number
}

const MemberCheckSummary = ({
  label,
  maxUtilization,
  checkType,
  allowedOverutilizationPercent = 0,
}: Props): ReactElement => {
  const theme = useTheme()
  const vibrationError = isVibrationError(checkType, maxUtilization)
  const over = vibrationError || isUtilizationError(maxUtilization, allowedOverutilizationPercent)
  const near = !over && isUtilizationWarning(maxUtilization, allowedOverutilizationPercent)
  return (
    <>
      <Box
        component="span"
        sx={{
          fontSize: 12,
          color: theme.palette.text.secondary,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: 180,
        }}
      >
        {label}
      </Box>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,

          fontSize: 12,
          fontWeight: 500,
          px: 0.75,
          py: 0.25,
          borderRadius: 0.75,
          background: over ? theme.palette.warning.main : near ? '#FFF1C9' : 'transparent',
          color: over ? '#fff' : near ? '#7A5A00' : theme.palette.text.primary,
          border: over || near ? 'none' : `1px solid ${theme.palette.divider}`,
          lineHeight: 1.2,
        }}
      >
        <Box
          component="span"
          sx={{ fontFamily: 'Roboto', fontSize: 10, opacity: over ? 0.9 : 0.7 }}
        >
          η
        </Box>
        {vibrationError ? 'ERR' : fmt(maxUtilization)}
      </Box>
    </>
  )
}

export default MemberCheckSummary
